import React from 'react';
import MenuItemList from '@active/react-ui/MenuItemList';
import MenuItem from '@active/react-ui/MenuItem';

const MenuItemsList = ({ data }) => (data ? (
  <MenuItemList>
    {
      data.map(item => (
        <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
      ))
    }
  </MenuItemList>
) : null);

export default MenuItemsList;
